export class AccountContract {

    async registerUser(data) {
        throw new Error(`${this.constructor.name}: registerUser(data) is not implemented.`);
    }

    async verifyEmail(data) {
        throw new Error(`${this.constructor.name}: verifyEmail(data) is not implemented.`);
    }

    async getDetails() {
        throw new Error(`${this.constructor.name}: getDetails() is not implemented.`);
    }

    async changeDetails(data) {
        throw new Error(`${this.constructor.name}: changeDetails(data) is not implemented.`);
    }

    async changePassword(data) {
        throw new Error(`${this.constructor.name}: changePassword(data) is not implemented.`);
    }

    async startPasswordReset(data) {
        throw new Error(`${this.constructor.name}: startPasswordReset(data) is not implemented.`);
    }

    async resetPassword(data) {
        throw new Error(`${this.constructor.name}: resetPassword(data) is not implemented.`);
    }

}
